const detail = () => import('PC/Pages/Detail');
const index = () => import('PC/Pages/Index');
const Login = () => import('PC/Pages/Login');
const cart = () => import('PC/Pages/Cart');
const pay = () => import('PC/Pages/Pay');
const SearchResult = () => import('PC/Pages/SearchResult');
const merchantShop = () => import('PC/merchantShop/merchantShop');
const order = () => import('PC/order/order');
const authentication = () => import('PC/authentication/authentication');
const memberList = () => import('PC/searchResults/memberList');
const certificate = () => import('PC/searchResults/certificate');
const feedback = () => import('PC/searchResults/feedback');
const shopList = () => import('PC/searchResults/shopList');
const reservationGoods = () => import('PC/searchResults/reservationGoods');
const reservationGoodsDetail = () => import('PC/searchResults/reservationGoodsDetail');


const pcRouter = [
  {
    path: '',
    redirect: 'index',
  },
  {
    path: 'index',
    component: index,
  },
  {
    path: 'detail',
    component: detail,
  },
  {
    path: 'login',
    component: Login,
  },
  {
    path: 'search',
    component: SearchResult,
  },
  {
    path: 'memberList',
    component: memberList,
  },
  {
    path: 'certificate',
    component: certificate,
  },
  {
    path: 'feedback',
    component: feedback,
  },
  {
    path: 'shopList',
    component: shopList,
  },
  {
    path: 'reservationGoods',
    component: reservationGoods,
  },
  {
    path: 'reservationGoodsDetail',
    component: reservationGoodsDetail,
  },
  {
    path: 'cart',
    component: cart,
    beforeEnter(to, from, next) {
      if (!localStorage.getItem('shop_access_token')) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    name: 'pay',
    path: 'pay',
    component: pay,
    beforeEnter(to, from, next) {
      if (!localStorage.getItem('shop_access_token')) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    path: 'merchantShop',
    component: merchantShop,
  },
  {
    path: 'order',
    component: order,
    beforeEnter(to, from, next) {
      if (!localStorage.getItem('shop_access_token')) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
  {
    path: 'authentication',
    component: authentication,
    beforeEnter(to, from, next) {
      if (!localStorage.getItem('shop_access_token')) {
        next('/PC/login?isLogin=true');
      } else {
        next();
      }
    },
  },
];

export default pcRouter;



// WEBPACK FOOTER //
// ./src/router/pc/index.js